import TradingHistoryDE from './TradingHistoryDE';
import { useOffersDE } from '../../../hooks/useOffers/useOffersDE';
import ApplicationLoader from '../../ApplicationLoader/ApplicationLoader';
import OffersCheck from '../../OffersCheck/OffersCheck';

const TradingHistoryWithOffersCheckDE = () => {
  const offersInformation = useOffersDE();

  return (
    <OffersCheck {...offersInformation}>
      {!offersInformation.documentRequirements ? (
        <ApplicationLoader />
      ) : (
        <TradingHistoryDE
          documentRequirements={offersInformation.documentRequirements}
        />
      )}
    </OffersCheck>
  );
};

export default TradingHistoryWithOffersCheckDE;
